import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';

export const didsListGet = createAsyncThunk('incoming/dids', async (params) => {
  return await apiInstance.get('/dids', { params });
});

export const didDetailsGetById = createAsyncThunk('incoming/dids-id', async (id) => {
  return await apiInstance.get(`/dids/${id}`);
});

export const didsAdd = createAsyncThunk('incoming/dids-add', async (payload) => {
  return await apiInstance.post('/dids', payload);
});

export const didsUpdate = createAsyncThunk('incoming/dids-update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/dids/${id}`, rest);
});

export const didsDelete = createAsyncThunk('incoming/dids-delete', async (id) => {
  return await apiInstance.delete(`/dids/${id}`);
});

export const didOptionGet = createAsyncThunk('incoming/dids-options', async () => {
  return await apiInstance.get('/dids');
});

export const didProcessOptionGet = createAsyncThunk('incoming/crm-process', async () => {
  return await apiInstance.get('/process?did_type=true');
});

export const didUserOptionGet = createAsyncThunk('agent-performance/user', async () => {
  return await apiInstance.get('/user?did_type=true ');
});

export const queuesOptionGet = createAsyncThunk('incoming/queues-options', async () => {
  return await apiInstance.get('/queues');
});

export const audioPromptsAllOptionGet = createAsyncThunk('incoming/audio_prompts', async () => {
  return await apiInstance.get('/audio_prompts');
});

export const audioPromptsListGet = createAsyncThunk('incoming/audio_prompts', async (params) => {
  return await apiInstance.get('/audio_prompts', { params });
});

export const queuesListGet = createAsyncThunk('incoming/queues', async (params) => {
  return await apiInstance.get('/queues', { params });
});

export const queuesDetailsGetById = createAsyncThunk('incoming/queues-id', async (id) => {
  return await apiInstance.get(`/queues/${id}`);
});

export const queuesAdd = createAsyncThunk('incoming/queues-add', async (payload) => {
  return await apiInstance.post('/queues', payload);
});

export const queuesUpdate = createAsyncThunk('incoming/queues-update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/queues/${id}`, rest);
});

export const queuesDelete = createAsyncThunk('incoming/queues-delete', async (id) => {
  return await apiInstance.delete(`/queues/${id}`);
});

export const ivrListGet = createAsyncThunk('incoming/ivr', async (params) => {
  return await apiInstance.get('/ivrs', { params });
});

export const ivrOptionsGet = createAsyncThunk('incoming/ivr-options', async () => {
  return await apiInstance.get('/ivrs');
});

export const ivrDetailsGetById = createAsyncThunk('incoming/ivr-id', async (id) => {
  return await apiInstance.get(`/ivrs/${id}`);
});

export const ivrAdd = createAsyncThunk('incoming/ivr-add', async (payload) => {
  return await apiInstance.post('/ivrs', payload);
});

export const ivrUpdate = createAsyncThunk('incoming/ivr-update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/ivrs/${id}`, rest);
});

export const ivrDelete = createAsyncThunk('incoming/ivr-delete', async (id) => {
  return await apiInstance.delete(`/ivrs/${id}`);
});

export const dynamicIvrListGet = createAsyncThunk('incoming/ivr_dynamic', async (params) => {
  return await apiInstance.get('/ivr_dynamic', { params });
});

export const dynamicIvrOptionsGet = createAsyncThunk('incoming/ivr_dynamic-options', async () => {
  return await apiInstance.get('/ivr_dynamic');
});

export const dynamicIvrDetailsGetById = createAsyncThunk('incoming/ivr_dynamic-id', async (id) => {
  return await apiInstance.get(`/ivr_dynamic/${id}`);
});

export const dynamicIvrAdd = createAsyncThunk('incoming/ivr_dynamic-add', async (payload) => {
  return await apiInstance.post('/ivr_dynamic', payload);
});

export const dynamicIvrUpdate = createAsyncThunk('incoming/ivr_dynamic-update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/ivr_dynamic/${id}`, rest);
});

export const dynamicIvrDelete = createAsyncThunk('incoming/ivr_dynamic-delete', async (id) => {
  return await apiInstance.delete(`/ivr_dynamic/${id}`);
});

export const audioPromptsDetailsGetById = createAsyncThunk(
  'incoming/audio_prompts-id',
  async (id) => {
    return await apiInstance.get(`/audio_prompts/${id}`);
  }
);

export const audioPromptsAdd = createAsyncThunk('incoming/audio_prompts-add', async (payload) => {
  return await apiInstance.post('/audio_prompts', payload);
});

export const audioPromptsUpdate = createAsyncThunk(
  'incoming/audio_prompts-update',
  async (payload) => {
    const { id, ...rest } = payload;
    return await apiInstance.put(`/audio_prompts/${id}`, rest);
  }
);

export const audioPromptsDelete = createAsyncThunk('incoming/audio_prompts-delete', async (id) => {
  return await apiInstance.delete(`/audio_prompts/${id}`);
});

export const dncListGet = createAsyncThunk('incoming/dnc', async (params) => {
  return await apiInstance.get('/dnc', { params });
});

export const dncListExport = createAsyncThunk('incoming/dnc/export-dnc', async () => {
  return await apiInstance.get('/dnc/export-dnc', { responseType: 'blob' });
});

export const dncAdd = createAsyncThunk('incoming/dnc-add', async (payload) => {
  return await apiInstance.post('/dnc', payload);
});

export const dncUpdate = createAsyncThunk('incoming/dnc-update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/dnc/${id}`, rest);
});

export const dncDelete = createAsyncThunk('incoming/dnc-delete', async (id) => {
  return await apiInstance.delete(`/dnc/${id}`);
});

export const dncUpload = createAsyncThunk('incoming/dnc/upload-dnc', async (payload) => {
  return await apiInstance.post('/dnc/upload-dnc', payload);
});

export const dncDeleteUpload = createAsyncThunk('incoming/dnc/import-delete', async (payload) => {
  return await apiInstance.post('/dnc/import-delete', payload);
});

export const inboundAclListGet = createAsyncThunk('incoming/inbound-acl', async (params) => {
  return await apiInstance.get('/inbound-acl/', { params });
});

export const inboundAclDetailsGetById = createAsyncThunk('incoming/inbound-acl-id', async (id) => {
  return await apiInstance.get(`/inbound-acl/${id}`);
});

export const inboundAclAdd = createAsyncThunk('incoming/inbound-acl-add', async (payload) => {
  return await apiInstance.post('/inbound-acl/', payload);
});

export const inboundAclUpdate = createAsyncThunk('incoming/inbound-acl-update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/inbound-acl/${id}`, rest);
});

export const inboundAclDelete = createAsyncThunk('incoming/inbound-acl-delete', async (id) => {
  return await apiInstance.delete(`/inbound-acl/${id}`);
});

const initialState = {
  didList: null,
  audioPromptsList: null,
  queuesList: null,
  ivrList: null,
  dynamicIvrList: null,
  dncList: null,
  inboundAclList: null
};

const incomingSlice = createSlice({
  name: 'incoming',
  initialState,
  reducers: {
    clearIncomingSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(didsListGet.fulfilled, (state, action) => {
      state.didList = action?.payload;
    });
    builder.addCase(audioPromptsListGet.fulfilled, (state, action) => {
      state.audioPromptsList = action?.payload;
    });
    builder.addCase(queuesListGet.fulfilled, (state, action) => {
      state.queuesList = action?.payload;
    });
    builder.addCase(ivrListGet.fulfilled, (state, action) => {
      state.ivrList = action?.payload;
    });
    builder.addCase(dynamicIvrListGet.fulfilled, (state, action) => {
      state.dynamicIvrList = action?.payload;
    });
    builder.addCase(dncListGet.fulfilled, (state, action) => {
      state.dncList = action?.payload;
    });
    builder.addCase(inboundAclListGet.fulfilled, (state, action) => {
      // GET /inbound-acl/ returns the rows in data[]; pagination comes back either as a
      // sibling `pagination` object or flattened onto the payload, so accept both.
      const { data, pagination, ...rest } = action?.payload || {};
      state.inboundAclList = {
        ...rest,
        ...(pagination || {}),
        data: data || []
      };
    });
  }
});

export default incomingSlice.reducer;
export const { clearIncomingSlice } = incomingSlice.actions;

export const selectDidList = (state) => state.incoming.didList;
export const useDidList = () => {
  const didList = useSelector(selectDidList);
  return useMemo(() => didList, [didList]);
};

export const selectAudioPromptsList = (state) => state.incoming.audioPromptsList;
export const useAudioPromptsList = () => {
  const audioPromptsList = useSelector(selectAudioPromptsList);
  return useMemo(() => audioPromptsList, [audioPromptsList]);
};

export const selectQueuesList = (state) => state.incoming.queuesList;
export const useQueuesList = () => {
  const queuesList = useSelector(selectQueuesList);
  return useMemo(() => queuesList, [queuesList]);
};

export const selectIvrList = (state) => state.incoming.ivrList;
export const useIvrList = () => {
  const ivrList = useSelector(selectIvrList);
  return useMemo(() => ivrList, [ivrList]);
};

export const selectDynamicIvrList = (state) => state.incoming.dynamicIvrList;
export const useDynamicIvrList = () => {
  const dynamicIvrList = useSelector(selectDynamicIvrList);
  return useMemo(() => dynamicIvrList, [dynamicIvrList]);
};

export const selectDncList = (state) => state.incoming.dncList;
export const useDncList = () => {
  const dncList = useSelector(selectDncList);
  return useMemo(() => dncList, [dncList]);
};

export const selectInboundAclList = (state) => state.incoming.inboundAclList;
export const useInboundAclList = () => {
  const inboundAclList = useSelector(selectInboundAclList);
  return useMemo(() => inboundAclList, [inboundAclList]);
};
